// extracted by mini-css-extract-plugin
export default {"root":"CheckBoxBase_root__dH3gW","circle":"CheckBoxBase_circle__XcCmt","checked":"CheckBoxBase_checked__7dyhK"};